import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  getKeyValue,
} from "@nextui-org/react";
import { useEffect, useState } from "react";

interface ProviderShareData {
  code: string;
  value: number;
}

const ShareConfig = () => {
  const [tableRows, setTableRows] = useState<ProviderShareData[]>([]);
  const [data, setData] = useState<ProviderShareData[] | undefined>(undefined);

  useEffect(() => {
    if (data) {
      setTableRows(data || []);
    }
  }, [data]);

  useEffect(() => {
    fetchShareConfig();
  }, []);

  const fetchShareConfig = () => {
    fetch(`${import.meta.env.VITE_GGR_API_URI}/config/share`)
      .then((res) => res.json())
      .then((data) => setData(data.data));
  };

  const columns = [
    {
      key: "code",
      label: "Code",
    },
    {
      key: "value",
      label: "Value",
    },
  ];

  return (
    <div>
      <div>
        <div className="font-ubuntu float-left text-center text-2xl  text-sm font-semibold text-white sm:text-lg">
          <p className="hidden sm:block">Reinvestment Config</p>
        </div>
        <div className="flex w-full flex-col gap-4"></div>
        {tableRows !== undefined && (
          <div className="w-full sm:mt-5">
            <div className="w-full overflow-x-auto">
              <Table
                removeWrapper
                className="table-striped table-striped-even table"
              >
                <TableHeader className="rounded-none" columns={columns}>
                  {(column) => (
                    <TableColumn key={column.key}>
                      <div className="white-op flex">{column.label}</div>
                    </TableColumn>
                  )}
                </TableHeader>
                <TableBody items={tableRows}>
                  {(item) => (
                    <TableRow key={item.code}>
                      {(columnKey) => (
                        <TableCell>
                          {columnKey === "no" ? (
                            getKeyValue(item, columnKey) + "."
                          ) : columnKey === "value" ? (
                            <div>
                              {parseFloat(getKeyValue(item, columnKey)) * 100 +
                                "%"}
                            </div>
                          ) : (
                            <div>{getKeyValue(item, columnKey)}</div>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareConfig;
